import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, signal } from '@angular/core';
import { AccessoriesViewService } from '@boels/helpers';
import {
  AccordionMode,
  BoelsProductReference,
  BoelsProductReferenceType,
  BOProduct,
} from '@boels/models';
import { Observable, Subscription } from 'rxjs';
import { AccessoriesViewComponent } from '../accessories-view/accessories-view.component';

@Component({
  selector: 'boels-product-acc-tab',
  templateUrl: './product-acc-tab.component.html',
  styleUrls: ['./product-acc-tab.component.scss'],
  imports: [CommonModule, AccessoriesViewComponent],
  providers: [AccessoriesViewService],
})
export class ProductAccTabComponent implements OnInit, OnDestroy {
  @Input() componentData: { product$: Observable<BOProduct> };

  private subs$: Subscription = new Subscription();

  $mandatoryAccessories = signal<BoelsProductReference[]>([]);
  $optionalAccessories = signal<BoelsProductReference[]>([]);

  readonly accordionMode = AccordionMode.MULTIPLE;

  ngOnInit(): void {
    this.subs$.add(
      this.componentData.product$.subscribe((product: BOProduct) => {
        if (product?.productReferences?.length) {
          const mandatoryAccessories: BoelsProductReference[] = [];
          const optionalAccessories: BoelsProductReference[] = [];

          product.productReferences.forEach((ref: BoelsProductReference) => {
            if (
              ref.referenceType === BoelsProductReferenceType.MANDATORY_HIRE ||
              ref.referenceType === BoelsProductReferenceType.MANDATORY_SALE
            ) {
              mandatoryAccessories.push(ref);
            } else if (
              ref.referenceType === BoelsProductReferenceType.OPTIONAL_HIRE ||
              ref.referenceType === BoelsProductReferenceType.OPTIONAL_SALE
            ) {
              optionalAccessories.push(ref);
            }
          });

          this.$mandatoryAccessories.set(mandatoryAccessories);
          this.$optionalAccessories.set(optionalAccessories);
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs$.unsubscribe();
  }
}
